import { useCallback, useEffect, useMemo, useState } from "react";
import { BrowserStorageService } from "@/browser-storage";

interface State {
  isSignedIn: boolean;
  token: string;
}

const storage = new BrowserStorageService<State>("@/hooks/use-auth");

export function useAuth(key?: string) {
  const [loaded, setLoaded] = useState<boolean>();
  const [state, setState] = useState<State | null>();

  useEffect(() => {
    if (!loaded) {
      const state = storage.getItem();
      setCookie(state);
      setState(state);
      setLoaded(true);
    }
  }, [loaded]);

  const signIn = useCallback(({ token }: { token: string }) => {
    const state = { token, isSignedIn: true };
    storage.setItem(state);
    setCookie(state);
    setState(state);
  }, [setState]);

  const signOut = useCallback(() => {
    const state = { token: "", isSignedIn: false };
    storage.setItem(state);
    setCookie(state);
    setState(state);
  }, [setState]);

  return useMemo(() => ({ ...state, signIn, signOut }), [state, signIn, signOut]);
}

function setCookie(state: State | null) {
  if (state?.token && state?.isSignedIn) {
    document.cookie = `x-apolocomercializadora-authorization=${encodeURIComponent(`Bearer ${state.token}`)};`;
  } else {
    document.cookie = "x-apolocomercializadora-authorization=; Max-Age=-99999999;";
  }
}
